import React from 'react';
import Utils from '../../common/utils/Utils';
import TableHeadings from '../../Batches/components/TableHeader';

const Table = ({ headings, reportData, className }) => {
  return (
    <table style={{margin: "8px 0px 0px", padding:0}} className={`table study ${className}`} >
      <tbody>
        <TableHeadings data={headings} />
        {Object.keys(reportData.stim_data).map(key => {
          const isTimeOrPercentage = key.split('_').map(item => item.toUpperCase()).includes('TIME');
          const end = isTimeOrPercentage ? 's' : '%';
          const decimalPlace = isTimeOrPercentage ? 1 : 0;
          const isNorms = reportData['norm_data']
          const isLastRow = key === "attention_per_1000_impressions_min"
          return (
            <tr key={key}>
              <td style={{borderBottom: isLastRow ? "unset" : ""}}>{Utils.Capitalize(key.split('_').join(' '))}</td>
              <td style={{borderBottom: isLastRow ? "unset" : ""}} >{Utils.DelimitNumbers(Number(reportData['stim_data'][key]).toFixed(decimalPlace))}{end}</td>
              {isNorms ?
                <td style={{borderBottom: isLastRow ? "unset" : ""}} >{Utils.DelimitNumbers(Number(reportData['norm_data'][key]).toFixed(decimalPlace))}{end}</td> :
                <td style={{borderBottom: isLastRow ? "unset" : ""}} >N/A</td>
              }
            </tr>
          );

        })}
      </tbody>
    </table>
  );
}


export default Table;

